import { ensureWebViewMediaPermissions, hasWebViewMediaPermissions, isWebViewMode } from '../utils/webviewBridge';
import { showMicrophoneRationaleIfNeeded } from '../utils/microphoneRationale';

export async function preflightWebVideoMediaAccess(): Promise<void> {
  if (isWebViewMode) {
    if (!hasWebViewMediaPermissions({ audio: true, video: true })) {
      await showMicrophoneRationaleIfNeeded();
    }
    ensureWebViewMediaPermissions({ audio: true, video: true });
  }
  if (!navigator.mediaDevices?.getUserMedia) {
    throw new Error('Failed to access microphone/camera');
  }

  let stream: MediaStream | null = null;
  try {
    stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true
      }
    });
  } catch (error) {
    console.error('Video handoff preflight failed:', error);
    throw new Error('Failed to access microphone/camera');
  } finally {
    try {
      stream?.getTracks().forEach((track) => {
        try {
          track.stop();
        } catch {
          // ignore
        }
      });
    } catch {
      // ignore
    }
  }
}
